import { useEffect } from 'react';

import { useIonToast } from '@ionic/react';

export const useUnhandledErrors = () => {
  const [presentToast] = useIonToast();
  useEffect(() => {
    window.addEventListener('unhandledrejection', function (e) {
      e.preventDefault();
    });

    window.addEventListener('error', async (e: any) => {
      if (
        e.message ===
          'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded' ||
        e.message === 'Script error.'
      ) {
        e.stopImmediatePropagation();
      } else {
        await presentToast({
          message: `Unhandled Error: ${e?.message}`,
          color: 'danger',
          buttons: [
            {
              text: 'Close',
              role: 'cancel',
            },
          ],
        });
      }

      return false;
    });
  }, []);
};
